export const VIBRATION_MARKS = [
  { value: 1, label: '1s' },
  { value: 20, label: '20s' },
];

export const PARAMS_MODES = Object.freeze({
  preset: 'preset',
  custom: 'custom',
});
